module.exports = __webpack_public_path__ + "static/media/dem_flo_con.92de9ed8.png";